import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Popover, PopoverInteractionKind, Position} from "@blueprintjs/core";
import InfoCircle from "../common/InfoCircle";
import countries from "../common/countries.json";
import StripeReplacementModal from '../modals/StripeReplacementModal';


class ViberChanel extends Component {
    state = {
        viberClientData: '',
        user: this.props.user,
        selectedSource: this.props.selectedSource,
        activatedCountries: [],
        selectedSourceFull: '',
        stripeReplacementModal: false
    }

    handleDate = (date) => {
        // console.log('initialDate: ', date)
        let dateFormatted = new Date(date.replace(/-/g, '/'));
        // console.log('dateFormatted: ', dateFormatted)
        if (this.state.user.locals) {
            let dateFormat = this.state.user.locals.date_format
            let timeFormat = this.state.user.locals.time_format
            // console.log('dateFormat: ', dateFormat)
            // console.log('timeFormat: ', timeFormat)
            // console.log('date: ', date)

            let dateOutput = '';
            let timeOutput = '';
            let dateTimeOutput = '';

            //date formatting according to user settings
            const dateObj = dateFormatted;
            const month = dateObj.getMonth() < 10 ? '0' + dateObj.getMonth() : dateObj.getMonth();
            const day = String(dateObj.getDate()).padStart(2, '0');
            const year = dateObj.getFullYear();

            switch (dateFormat) {
                case 'DD-MM-YYYY':
                    dateOutput = day + '-' + month + '-' + year;
                    break;
                case 'MM-DD-YYYY':
                    dateOutput = month + '-' + day + '-' + year
                    break;
                case 'YYYY-MM-DD':
                    dateOutput = year + '-' + month + '-' + day
                    break;
            }
            //console.log('dateOutput: ', dateOutput)

            //time formatting according to user settings

            let hours = dateFormatted.getHours();
            let minutes = dateFormatted.getMinutes();
            let ampm = hours >= 12 ? 'PM' : 'AM';

            minutes = minutes < 10 ? '0' + minutes : minutes;

            if (timeFormat === 'AM/PM') {
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                timeOutput = hours + ':' + minutes + ampm;
            } else {
                timeOutput = hours + ':' + minutes
            }

            dateTimeOutput = dateOutput + ' ' + timeOutput
            return dateTimeOutput
        } else {
            return date.toLocaleString()
        }

    }


    componentDidMount = async () => {
        let selectedSourceFull = ''
        if (this.state.user.sources.data.length > 0) {

            selectedSourceFull = await this.state.user.sources.data.filter(
                source => {
                    // console.log('current source Id : ', source.id)
                    // console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === this.state.selectedSource.toString()

                }
            )
        }
        //console.log('viber cdm - selectedSourceFull: ', selectedSourceFull);
        let viberClient = selectedSourceFull[0].viber_client
        // console.log('viber cdm - selectedSourceFull: ', selectedSourceFull)
        let selectedSourceViberCountries = viberClient ? viberClient.activated_countries : [];
        let i = 0;

        let activatedCountries = []
        for (i; i < selectedSourceViberCountries.length; i++) {
            let activatedCountry = countries.find(country => {
                if (country.code === selectedSourceViberCountries[i]) {
                    return country
                } else {
                    return null
                }

            })
            activatedCountries.push(activatedCountry)
        }
        // console.log('activatedCountries: ', activatedCountries)

        //activatedCountries.pop()
        if (selectedSourceFull) {
            await this.setState({
                viberClientData: viberClient,
                activatedCountries,
                selectedSourceFull
            })
        }
    }


    componentDidUpdate = async () => {
        if (this.state.selectedSource !== this.props.selectedSource) {
            let selectedSource = this.props.selectedSource
            let selectedSourceFull = await this.state.user.sources.data.filter(
                source => {
                    // console.log('current source Id : ', source.id)
                    // console.log('selectedSource id :', this.state.selectedSource);
                    return source.id.toString() === selectedSource.toString()

                }
            )

            let viberClient = selectedSourceFull[0].viber_client
            let selectedSourceViberCountries = viberClient ? viberClient.activated_countries : []
            let i = 0;
            let activatedCountries = []

            if (selectedSourceViberCountries && selectedSourceViberCountries.length) {
                selectedSourceViberCountries.map(viberCountry => {
                    let activatedCountry = countries.find(country => country.code === selectedSourceViberCountries[i])
                    if (activatedCountry) {
                        activatedCountries.push(activatedCountry)
                    }
                })
            }

            // for (i; i < selectedSourceViberCountries.length; i++) {
            //     let activatedCountry = countries.find(country => {
            //         if (country.code === selectedSourceViberCountries[i]) {
            //             return country
            //         } else {
            //             return null
            //         }
            //     })
            //     activatedCountries.push(activatedCountry)
            // }

            if (selectedSourceFull) {
                await this.setState({
                    viberClientData: viberClient,
                    activatedCountries,
                    selectedSourceFull,
                    selectedSource
                })
            }
        }

    }


    render() {

        let viberCredit = this.state.viberClientData ? this.state.viberClientData.available_credit ? Number(parseFloat(this.state.viberClientData.available_credit)).toFixed(2) : '' : ''
        //console.log('viberCredit: ', viberCredit)
        let workspaceCredit = this.state.viberClientData ?
            this.state.selectedSourceFull[0] ?
                this.state.selectedSourceFull[0].project_balance ?
                    Number(parseFloat(this.state.selectedSourceFull[0].project_balance.credits)).toFixed(2)
                    : 0
                : 0 : ''

        //console.log('workspaceCredit: ', workspaceCredit)

        let totalBalance = this.state.viberClientData ? (Number(viberCredit) + Number(parseFloat(workspaceCredit))).toFixed(2) : ''
        //console.log('totalBalance: ', totalBalance)
        // console.log('viberClientData: ', this.state.viberClientData)
        return (
            <div id='viber-channel' className='channel-container'>
                <div className="channel-heading-container">
                    <h3 className='all-caps'>Viber</h3>
                    <p className='green ' style={{cursor: "pointer", marginBottom: 0}}>
                        {this.state.viberClientData ?
                            this.state.viberClientData.apply_status === 'active' ?
                                <span className='enabled-label'>Enabled</span>
                                :
                                this.state.viberClientData.apply_status === 'requested' ?
                                    <span className='required-label'>Requested</span>
                                    :
                                    ''
                            :
                            ''
                        }
                        <Popover
                            interactionKind={PopoverInteractionKind.CLICK}

                            position={Position.LEFT_TOP}
                            minimal={true}
                        >
                            <span className="fas fa-ellipsis-v" style={{color: 'black', marginLeft: 10}}></span>
                            <div className="three-dots-popover padding-10">
                                <a href='mailto:viber@emitto.io'>
                                    {/*<a id="team_delete_btn" onClick={() => console.log('Disable clicked')}*/}
                                    {/*   href="#">Disable {this.state.fb_spinner ?*/}
                                    {/*    <i className='fa fa-spin fa-spinner'></i> : ''}</a>*/}
                                    Request a Pause
                                </a>
                            </div>
                        </Popover>
                    </p>
                </div>
                {this.state.viberClientData && this.state.viberClientData.apply_status === 'active' ?
                    <div>
                        <div id='viber-available' className="flex-row space-between">
                            <div id='viber-credits' className="field-container">
                                <div className="display-flex space-between m-m-b">
                                    <h3>Viber Credits <InfoCircle
                                        icon={'question-grey'}
                                        infoCircleContent={
                                            <p className='info-circle-content'>
                                                Monthly Prepaid Credits expire by the end of the current month and
                                                Top-Up
                                                Credits remain on your balance until you spend them. After spending the
                                                Monthly
                                                Prepaid Credits you will have to Add Credits in order to send more
                                                campaigns in
                                                the current month.
                                            </p>
                                        }
                                    /></h3>

                                    <div className="grey-label">
                                        Your Viber Monthly Prepaid Credits expire on {
                                        this.state.viberClientData.balance_expiration_date ?
                                            this.handleDate(this.state.viberClientData.balance_expiration_date).split(' ')[0]
                                            : ''
                                    }
                                    </div>
                                </div>
                                <div className="display-flex justify-content-space">
                                    <div className="grey-sub-container">
                                        <div className="value">
                                            {Number(totalBalance)}
                                        </div>
                                        <div className="value-description">Total Credits</div>
                                    </div>
                                    <div id='viber-balance-container' className="grey-sub-container">
                                        <div className="value">
                                            {
                                                this.state.viberClientData.available_credit ? Number(parseFloat(this.state.viberClientData.available_credit)
                                                    //    .slice(0, -1)
                                                ).toFixed(2) : '0.00'}
                                        </div>
                                        <div className="value-description">Viber Monthly Prepaid Credits</div>
                                    </div>
                                    <div className="top-up-container">
                                        <div className="grey-sub-container">
                                            <div
                                                className="value">
                                                {
                                                    this.state.selectedSourceFull[0] ?
                                                        this.state.selectedSourceFull[0].project_balance ?
                                                            Number(parseFloat(this.state.selectedSourceFull[0].project_balance.credits)).toFixed(2)
                                                            : '0.00'
                                                        : '0.00'
                                                }
                                            </div>
                                            <div className="value-description">Workspace Balance<br/>
                                                <span className='text-light-grey'>(non expiring)</span>
                                            </div>
                                        </div>
                                        {/*<Link to='/top-up/add-funds'>*/}
                                        {/*    <button className="btn-action m-m-b"*/}
                                        {/*            onClick={() => this.props.history.push('/top-up/add-funds')}>*/}
                                        {/*        Add Credits*/}
                                        {/*    </button>*/}
                                        {/*</Link>*/}

                                        <button className="btn-action m-m-b"
                                                onClick={() => this.props.history.push('/top-up/add-credits')}
                                            // onClick={() => this.setState({stripeReplacementModal:true})}
                                        >
                                            Add Credits
                                        </button>
                                        {/*<StripeReplacementModal*/}
                                        {/*    showModal={this.state.stripeReplacementModal}*/}
                                        {/*    handleClose={() => this.setState({stripeReplacementModal: false})}*/}
                                        {/*    maxWidth={600}*/}
                                        {/*    history={this.props.history}*/}
                                        {/*    user={this.props.user}*/}
                                        {/*    updateUserFromServer={this.props.updateUserFromServer}*/}
                                        {/*/>*/}
                                    </div>

                                </div>

                            </div>
                            <div id='activated-countries' className="field-container">
                                <h3 className='m-m-b'>Activated Countries</h3>
                                <div className="flex-row">
                                    {/*{console.log('this.state.activatedCountries: ', this.state.activatedCountries)}*/}
                                    {
                                        this.state.activatedCountries.map((country, index) => {
                                            // console.log('country: ', country)
                                            return <span key={index}>{country ? country.flag : ''}</span>
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div id='viber-business-profile-info' className="full-field-container ">
                            <h3>Viber Business Profile <InfoCircle
                                icon={'question-grey'}
                                infoCircleContent={
                                    <p className='info-circle-content'>
                                        Details about your Viber Business Profile officially registered on Viber through
                                        Emitto
                                        service.
                                    </p>
                                }
                            /></h3>


                            <div className="flex-row m-lg-t">
                                <div className="info-section sender-info">
                                    <div className='m-t-b'>
                                        <p>Brand Name:</p>
                                        <span
                                            className='text-bold'>{this.state.viberClientData && this.state.viberClientData.brand_name ? this.state.viberClientData.brand_name :
                                            this.state.viberClientData.project_name}</span>
                                    </div>
                                    <div>
                                        <p>Website:</p>
                                        <span className='text-bold'>{this.state.viberClientData.website}</span>
                                    </div>
                                </div>
                                <div className="info-section about-info">
                                    <p>About</p>
                                    <p>{this.state.viberClientData.about_brand}</p>
                                </div>
                                <div className="info-section image-info">
                                    <p>Sender image:</p>
                                    <img src={this.state.viberClientData.brand_photo} alt="Sender image"/>
                                </div>
                            </div>

                        </div>
                        <p className='grey-label m-m-t'>For any updates or changes to your business profile, please send
                            us
                            a request to <a href="mailto:viber@emitto.io">viber@emitto.io</a> with the related
                            information.
                            We’ll forward your request to Viber and manage the entire process.</p>
                    </div>
                    :
                    this.state.viberClientData ?
                        <div className='stripe-loader-redirect no-background'>
                            <h2>CHOOSE YOUR VIBER BUSINESS<br/>
                                MONTHLY SUBSCRIPTION</h2>
                            <div className='main-container'>
                                <div className='select-container'>
                                    <div
                                        className={this.state.selectedOption === 'EuRegistered' ? 'single-selection active' : 'single-selection'}
                                        onClick={() => this.props.history.push('/viber-subscription/select-plan', {planType: 'Region A'})}
                                    >
                                        <img src='/img/viber/globe-europe-solid.png'/>
                                        <div className='title-container'>
                                            <h3>Viber Business</h3>
                                            <p>Region A</p>
                                        </div>
                                        <p className='price'><span>$200</span>/month</p>


                                        <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                            to:</span><br/>
                                            Russia, Belarus, Bulgaria, Greece,
                                            Hungary, Iraq, Moldova, Ukraine</p>
                                        <div className='credits-included-container'>
                                            <p><span>13k</span> /month<br/>
                                                Viber Credits Included</p>
                                        </div>
                                    </div>
                                    <div
                                        className={this.state.selectedOption === 'AnyOther' ? 'single-selection active' : 'single-selection'}
                                        onClick={() => this.props.history.push('/viber-subscription/select-plan', {planType: 'Region B'})}
                                    >
                                        <img src='/img/viber/globe-americas-solid.png'/>
                                        <div className='title-container'>
                                            <h3>Viber Business</h3>
                                            <p>Region B</p>
                                        </div>
                                        <p className='price'><span>$150</span>/month</p>
                                        <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                            to:</span><br/>
                                            All other countries</p>
                                        {
                                            this.state.anyOtherLoader ?
                                                <img className='any-other-loader-img' src="/img/chart-loader.svg"
                                                     alt="Chart Loader"/>
                                                :
                                                ''
                                        }
                                        <div className='credits-included-container'>
                                            <p><span>10k</span> /month<br/>
                                                Viber Credits Included</p>
                                        </div>
                                    </div>
                                </div>
                                <p className='bottom-link'>Your Viber Business Subscription Comes With Included<br/>
                                    <a>Viber Monthly Prepaid Credits</a>.</p>
                            </div>
                        </div>
                        :
                        <div className='stripe-loader-redirect no-background margin-top-20'>
                            <h4>Viber for Business is an Add-on and requires a minimal monthly subscription
                                based on your campaign destination countries.</h4>
                            <div className='main-container'>
                                <div className='select-container non-clickable'>
                                    <div className='single-selection'>
                                        <img src='/img/viber/globe-europe-solid.png'/>
                                        <div className='title-container'>
                                            <h3>Viber Business</h3>
                                            <p>Region A</p>
                                        </div>
                                        <p className='price'><span>$200</span>/month</p>


                                        <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                            to:</span><br/>
                                            Russia, Belarus, Bulgaria, Greece,
                                            Hungary, Iraq, Moldova, Ukraine</p>
                                        <div className='credits-included-container'>
                                            <p><span>13k</span> /month<br/>
                                                Viber Credits Included</p>
                                        </div>
                                    </div>
                                    <div className='single-selection'>
                                        <img src='/img/viber/globe-americas-solid.png'/>
                                        <div className='title-container'>
                                            <h3>Viber Business</h3>
                                            <p>Region B</p>
                                        </div>
                                        <p className='price'><span>$150</span>/month</p>
                                        <p className='bottom-text blue-text'><span className='small-text'>Send campaigns
                                            to:</span><br/>
                                            All other countries</p>
                                        {
                                            this.state.anyOtherLoader ?
                                                <img className='any-other-loader-img' src="/img/chart-loader.svg"
                                                     alt="Chart Loader"/>
                                                :
                                                ''
                                        }
                                        <div className='credits-included-container'>
                                            <p><span>10k</span> /month<br/>
                                                Viber Credits Included</p>
                                        </div>
                                    </div>
                                </div>
                                <button
                                    className='btn btn-action margin-top-20'
                                    onClick={() => window.open('https://emitto.io/viber-new-sender-name/')}
                                >
                                    Request Viber Business Profile
                                </button>
                                <p className='bottom-link'>The subscription comes with<br/>
                                    <a href="https://emitto.io/viber-message-cost" target="_blank">additional Viber
                                        Credits included each month</a>.</p>
                            </div>
                        </div>
                }
            </div>
        )
    }
}


export default ViberChanel;